import React from 'react';
import classNames from 'classnames';

import { I18N } from './translate';

interface IProps {
  freeExpeditedShipping?: boolean;
  freeShipping?: boolean;
  localPickupOnly?: boolean;
}

function getNudgeLanguage(props) {
  if (props.freeExpeditedShipping) return 'freeExpeditedShipping';
  if (props.freeShipping) return 'freeShipping';
  if (props.localPickup) return 'localPickup';
  return false;
}

export default function ListingCardNudge(props: IProps) {
  const classes = classNames(
    'listing-card-nudge',
    { 'listing-card-nudge--expedited': props.freeExpeditedShipping },
    { 'listing-card-nudge--free-shipping': props.freeShipping },
    { 'listing-card-nudge--local-pickup': props.localPickupOnly },
  );

  const i18nKey = getNudgeLanguage(props);
  if (!i18nKey) return null;

  return (
    <div className={classes}>
      <div className="listing-card-nudge__icon" />
      <I18N
        text={`commons.listingCardNudge.${i18nKey}`}
      />
    </div>
  );
}
